/* eslint-disable global-require */

import * as React from "react";
import { cls } from "@utdanningsdirektoratet/utils/cls";
import styles from "./Logo.module.less";

type LogoProps = {
  type?: "short" | "legacy";
  large?: boolean;
  negative?: boolean;
  className?: string;
  alt?: string;
  image?: string;
};
const code = ["ArrowUp", "ArrowUp", "ArrowDown", "ArrowDown", "ArrowLeft", "ArrowRight", "ArrowLeft", "ArrowRight", "b", "a"];

const getLogo = (type?: string): string => {
  switch (type) {
    case "short":
      return require("./images/udir.svg");
    case "legacy":
      return require("./images/udir-happy.svg");
    default:
      return require("./images/utdanningsdirektoratet.svg");
  }
};

const getNegativeLogo = (type?: string): string => {
  switch (type) {
    case "short":
      return require("./images/udir_neg.svg");
    case "legacy":
      return require("./images/udir-happy.svg");
    default:
      return require("./images/utdanningsdirektoratet_neg.svg");
  }
};

const Logo: React.FC<LogoProps> = ({ image, large, alt = "Utdanningsdirektoratet", className, negative, ...rest }) => {
  const n = React.useRef(0);
  const [type, setType] = React.useState(rest.type);

  const onKeyDown = (e: KeyboardEvent): void => {
    if (n.current === code.length - 1 && e.key !== code[n.current]) {
      n.current = 0;
    } else if (e.key === code[n.current]) {
      n.current += 1;
      if (n.current === code.length) {
        n.current = 0;
        setType("legacy");
        document.removeEventListener("keydown", onKeyDown);
      }
    } else {
      n.current = 0;
    }
  };

  React.useEffect(() => {
    if (!image) document.addEventListener("keydown", onKeyDown);
    return () => {
      if (!image) document.removeEventListener("keydown", onKeyDown);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const logoClass = cls(
    {
      [styles.logo]: true,
      [styles.logoLarge]: large,
    },
    className
  );

  return (
    // <picture>
    //   {/* <source srcSet={image || getNegativeLogo(type)} media="(prefers-color-scheme: dark)" /> */}
    <img src={image || (negative ? getNegativeLogo(type) : getLogo(type))} className={logoClass} alt={alt} />
    // </picture>
  );
};

export default Logo;
